import type { PayloadAction } from "@reduxjs/toolkit";
import type { currentSurveySliceState } from "@survey-types/survey.core.types";
import { reorderArrayItems } from "@survey/utils/reducerFactory";

// =====================================
// SURVEY SECTIONS MANAGEMENT
// =====================================

export const sectionReducers = {
  reorderSections: (
    state: currentSurveySliceState,
    action: PayloadAction<{
      sourceIndex: number;
      destinationIndex: number;
    }>,
  ) => {
    if (state.currentSurvey?.sections) {
      const { sourceIndex, destinationIndex } = action.payload;
      state.currentSurvey.sections = reorderArrayItems(
        state.currentSurvey.sections,
        sourceIndex,
        destinationIndex,
      );
    }
  },

  deleteSection: (
    state: currentSurveySliceState,
    action: PayloadAction<{ sectionId: string }>,
  ) => {
    if (state.currentSurvey?.sections) {
      const { sectionId } = action.payload;
      state.currentSurvey.sections = state.currentSurvey.sections.filter(
        (section) => section.surveySectionId !== sectionId,
      );
    }
  },

  addSectionPdf: (
    state: currentSurveySliceState,
    action: PayloadAction<{
      surveySectionMediaId: string;
      mediaName: string;
      order: number;
      mediaUrl: string;
      mediaSize: number;
      sectionId: string;
    }>,
  ) => {
    if (state.currentSurvey?.sections) {
      const {
        surveySectionMediaId,
        mediaName,
        order,
        mediaUrl,
        mediaSize,
        sectionId,
      } = action.payload;
      const sectionIndex = state.currentSurvey.sections.findIndex(
        (section) => section.surveySectionId === sectionId,
      );

      if (sectionIndex !== -1) {
        const section = state.currentSurvey.sections[sectionIndex];
        section.pdfs.push({
          surveysectionId: sectionId,
          surveySectionMediaId,
          mediaName,
          order,
          mediaUrl,
          mediaSize,
        });
      }
    }
  },

  updateSectionPdf: (
    state: currentSurveySliceState,
    action: PayloadAction<{
      sectionId: string;
      pdfId: string;
      updates: Partial<{ mediaName: string }>;
    }>,
  ) => {
    if (state.currentSurvey?.sections) {
      const { sectionId, pdfId, updates } = action.payload;
      const sectionIndex = state.currentSurvey.sections.findIndex(
        (section) => section.surveySectionId === sectionId,
      );

      if (sectionIndex !== -1) {
        const section = state.currentSurvey.sections[sectionIndex];
        if (section.pdfs) {
          const pdfIndex = section.pdfs.findIndex(
            (pdf) => pdf.surveySectionMediaId === pdfId,
          );

          if (pdfIndex !== -1) {
            section.pdfs[pdfIndex] = {
              ...section.pdfs[pdfIndex],
              ...updates,
            };
          }
        }
      }
    }
  },

  deleteSectionPdf: (
    state: currentSurveySliceState,
    action: PayloadAction<{
      sectionId: string;
      pdfId: string;
    }>,
  ) => {
    if (state.currentSurvey?.sections) {
      const { sectionId, pdfId } = action.payload;
      const sectionIndex = state.currentSurvey.sections.findIndex(
        (section) => section.surveySectionId === sectionId,
      );

      if (sectionIndex !== -1) {
        const section = state.currentSurvey.sections[sectionIndex];
        if (section.pdfs) {
          section.pdfs = section.pdfs.filter(
            (pdf) => pdf.surveySectionMediaId !== pdfId,
          );
        }
      }
    }
  },
};
